// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2L4sv","expireSoon":"styles_expireSoon__2cD0z"};